import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { rowData, roleDropdown } from './helpers';
import { t } from 'i18next';

interface AccountModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: {
    id:string;
    name: string;
    email: string;
    roleName: string;
    phoneNumber: string;
    isActive: boolean;
    password:string;
  }) => void;
  rowData: rowData;
  isCreate?: boolean;
}

const AccountModal = ({ open, onClose, onSubmit , rowData, isCreate = false}: AccountModalProps) => {
  const [id, setID] = useState<string>(rowData.id);
  const [name, setName] = useState<string>(rowData.name);
  const [password, setPassword] = useState<string>('');
  const [email, setEmail] = useState<string>(rowData.email);
  const [roleName, setRoleName] = useState<string>(rowData.roleName);
 // const [companyName, setCompanyName] = useState<string>(rowData.companyName);
  const [phoneNumber, setPhoneNumber] = useState<string>( rowData.phoneNumber);
  const [isActive, setIsActive] = useState<boolean>(rowData.isActive);
  const [lastUpdatedBy, setLastUpdatedBy] = useState<string>(rowData.lastUpdatedBy);
  const [lastUpdatedAt, setLastUpdatedAt] = useState<string>('');


  useEffect(() => {

    setID(rowData.id);
    setName(rowData.name);
    setPassword('');
    setEmail(rowData.email);
    setRoleName(rowData.roleName);
    //setCompanyName(rowData.companyName);
    setPhoneNumber(rowData.phoneNumber);

  }, [rowData])

  const handleSubmit = () => {
    if (roleName) {
      onSubmit({
        id,
        name,
        email,
        roleName,
        password,
        phoneNumber,
        isActive,
      });
      handleClose();
    }
  };

  const handleClose = () => {

    setID('');
    setName('');
    setPassword('');
    setEmail('');
    setRoleName('');
    setPhoneNumber('');
    setIsActive(false);
    setLastUpdatedBy('');
    setLastUpdatedAt('');

    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>{ isCreate? t('Create user') : t('Edit user')}</DialogTitle>
      <DialogContent>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box sx={{ mt: 2 }}>
          { !isCreate && <TextField
              variant="filled"
              label={t('ID')}
              value={id}
              fullWidth
              disabled
              sx={{ mb: 2 }}
            />
          }
          <TextField
              label={t('Name')}
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
              required
              sx={{ mb: 2 }}
            />
          { isCreate && <TextField
              label={t('Password')}
              type={'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              required
              sx={{ mb: 2 }}
            />
          }
            <TextField
              label={t('Email')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              required
              sx={{ mb: 2 }}
            />
            <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">{`${t('Role')}*`}</InputLabel>
              <Select
                label={t('Role')}
                value={roleName}
                onChange={(e) => setRoleName(e.target.value)}
                fullWidth
                required
                sx={{ mb: 2 }}
              >
                {roleDropdown.map((item) => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label={t('Phone Number')}
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              fullWidth
              required
              sx={{ mb: 2 }}
            />
          </Box>
        </LocalizationProvider>

      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}> {t('Cancel')}</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!roleName || !name || !email || !phoneNumber}
        >
          {t('Submit')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccountModal;